import * as React from 'react'

import { Box, Text } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'

import { historicChangesTranslations } from 'modules/bookkeepers/lib/dynamicTranslations'
import type { IncidenceChangeItem, IncidenceChangeValue } from 'modules/payroll_bundle/lib/types'

interface Props {
  previousValue?: IncidenceChangeValue
  currentValue?: IncidenceChangeValue
  change: IncidenceChangeItem
  isManualIncidence: boolean
}

const IncidenceChangesItem = ({
  previousValue,
  currentValue,
  change,
  isManualIncidence,
}: Props) => {
  const author = change.changedBy
  const currentFieldValue = currentValue?.value ? `${currentValue.value}` : ''
  const previousFieldValue = previousValue?.value ? `${previousValue.value}` : ''

  return (
    <>
      <Text.Normal size="300" weight="medium">
        {historicChangesTranslations(change.id, currentFieldValue)}
      </Text.Normal>
      {!!currentFieldValue && (
        <Box gap="s6">
          <Box background="grey200" paddingY="s16" paddingX="s24" borderRadius={{ all: 'abs008' }}>
            <Text.Normal size="300" overflowWrap>
              {!!previousFieldValue && !isManualIncidence && (
                <>
                  <del>{previousFieldValue}</del> →{' '}
                </>
              )}
              {currentFieldValue}
            </Text.Normal>
          </Box>
          {author && (
            <Text.Normal size="100" weight="normal">
              {i18n.t('bookkeepers.incidence.incidence_status_text.by_text', { author })}
            </Text.Normal>
          )}
        </Box>
      )}
    </>
  )
}

export default IncidenceChangesItem
